import { Controller } from "@hotwired/stimulus"

// Automatically computes moment = weight × arm for correction rows
export default class extends Controller {
  static targets = ["weight", "arm", "moment"]

  connect() {
    this.calculate()
  }

  calculate() {
    if (!this.hasWeightTarget || !this.hasArmTarget || !this.hasMomentTarget) return
    const weight = parseFloat(this.weightTarget.value) || 0
    const arm = parseFloat(this.armTarget.value) || 0
    this.momentTarget.value = weight && arm ? (weight * arm).toFixed(2) : ""
  }
}
